<template>
    <section class="section">
        <div class="title">动态收藏夹</div>
        <div class="count">{{activity}}个动态</div>
        <div v-show="!is_loading && !activity" class="empty">
            <i class="icon-empty"></i>
            空间主人暂时还没有收藏动态哦~
        </div>
        <div v-show="is_loading" class="empty">
            <div class="loading-big"></div>
        </div>

        <div>
            <div class="opus-list df">
                <div v-for="v in activities" class="opus-box">
                    <a :href="`/dancers/activities/${v.id}`" class="opus-link" target="_blank" :style="`background-image: url('${v.thumb}')`">
                        <!--<div class="amount">6P</div>-->
                    </a>

                    <a :href="`/dancers/activities/${v.id}`" class="opus-title-link" target="_blank">{{v.title}}</a>

                    <div class="opus-meta-box">
                        收藏于{{$time(v.collect_time)}}
                        <set v-if="id === uid" @send="del(v.id)"></set>
                    </div>
                </div>
            </div>
            <el-pagination v-if="activity > 20" background layout="total, prev, pager, next" @current-change="nextPage" :page-size="20" :total="activity"></el-pagination>
        </div>

    </section>
</template>

<script>
    import set from './Set';

    export default {
        components: {
            set,
        },
        props: {
            activity: Number,
        },
        data: () => ({
            is_loading: true,
            is_paging: false,
            is_deleting: false,
            activities: [],
        }),
        computed: {
            id() {
                return +this.$route.params.id;
            },
            user() {
                return this.$store.state.user;
            },
            uid() {
                return this.user.id;
            },
            sign() {
                return this.$store.state.sign;
            },
        },
        methods: {
            async nextPage(page) {
                if (this.is_paging) return;
                this.is_paging = true;
                this.activities = await this.api.get(`users/${this.id}/collect/activities`, {page}).catch(this.err);
                window.scrollTo(0, 0);
                this.is_paging = false;
            },
            async del(id) {
                if (this.is_deleting) return;
                this.is_deleting = true;
                const {api} = this;
                await api.del(`dancers/activities/${id}/collect`).catch(this.err);
                this.$emit('activityDecr');
                this.alert.suc('已取消收藏');
                this.activities = await api.get(`users/${this.id}/collect/activities`).catch(this.err);
                this.is_deleting = false;
            },
        },
        async beforeMount() {
            this.activities = await this.api.get(`users/${this.id}/collect/activities`).catch(this.err);
            this.is_loading = false;
        }
    }
</script>

<style scoped>
    @import "../../../../static/css/views/space/collect/common.css";
    @import "../../../../static/css/views/space/collect/activity.css";
</style>


// WEBPACK FOOTER //
// src/views/space/collect/Activity.vue